import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-section',
  templateUrl: './risk-section.component.html',
  styleUrls: ['./risk-section.component.scss'],
  standalone: true
})
export class RiskSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.initAnimations();
  }

  private initAnimations(): void {
    // Animate risk content on scroll
    setTimeout(() => {
      const riskContent = document.querySelector('.risk-content');
      if (riskContent) {
        riskContent.classList.add('animate-in');
      }
    }, 500);
  }
}
